<template>

    <tabs-section
        class="c-field_pain"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"
        :title="title"
        :empty="value && value.length === 0"
        :saved="value !== null"
        @history="openHistory"
        @next="save">

        <visit-history-previous
            v-if="lastVisit !== null && lastValueExist"
            @copy="copyValue">
            <p v-html="lastValue"></p>
        </visit-history-previous>

        <form-pain
            :label="label"
            :name="name"
            v-model="newValue"
            speech-to-text>
        </form-pain>

        <visit-history-modal ref="painHistoryModal" :title="title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_pain__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                <div class="c-field_pain__row" v-if="item.value.length">
                    <div class="c-field_pain__bodies">
                        <form-pain-body
                            disabled
                            name="front"
                            caption="widok z przodu"
                            image="body-front.svg"
                            :points="item.value">
                        </form-pain-body>
                        <form-pain-body
                            disabled
                            name="left_side"
                            caption="widok z lewej strony"
                            image="body-left.svg"
                            :points="item.value">
                        </form-pain-body>
                        <form-pain-body
                            disabled
                            name="back"
                            caption="widok z tyłu"
                            image="body-back.svg"
                            :points="item.value">
                        </form-pain-body>
                        <form-pain-body
                            disabled
                            name="right_side"
                            caption="widok z prawej strony"
                            image="body-right.svg"
                            :points="item.value">
                        </form-pain-body>
                    </div>
                    <v-table
                        class="c-field_pain__legend">
                        <thead>
                        <th>LP.</th>
                        <th>Opis</th>
                        <th>Skala VAS</th>
                        </thead>
                        <tbody>
                        <tr
                            class="c-field_pain__legend-row"
                            v-for="point in item.value"
                            :key="point.id">
                            <td class="c-field_pain__legend-id">
                                <span>{{ point.id + 1 }}</span>
                            </td>
                            <td class="c-field_pain__legend-desc">
                                {{ point.name }}
                            </td>
                            <td class="c-field_pain__legend-vas">
                                {{ point.vas_scale }}
                            </td>
                        </tr>
                        </tbody>
                    </v-table>
                </div>
                <p v-else>Brak punktów</p>
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormPain, FormPainBody} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'
import VTable from 'Components/VTable'

import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'
import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'

import noReact from 'Utils/NoReact'

export default {

    name: 'VisitFieldPainMap',

    props: {
        value: Array,
        name: String,
        label: String,
        title: String
    },

    data() {
        return {
            fieldHistory: [],
            newValue: noReact(this.value) || []
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit']),
        lastValueExist() {
            return typeof this.lastVisit[this.name] !== 'undefined'
                && this.lastVisit[this.name] !== null
                && this.lastVisit[this.name].length > 0
        },
        lastValue() {
            if (!this.lastValueExist)
                return ''

            let val = ''

            for (let i in this.lastVisit[this.name]) {
                let point = this.lastVisit[this.name][i]
                val += `<strong>${point.name}</strong> o sile bólu <strong>${point.vas_scale}</strong> w skali VAS. <br>`
            }
            return val
        },
        nextLabel() {
            if (!this.isEdited || (this.value === null && this.newValue.length === 0))
                return 'Dalej'
            return 'Zapisz'
        },
        isEdited() {
            return !this.newValue.compare(this.value)
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: this.newValue,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 2000)
                nextSection()
            }).catch((error) => {
                this.$alert.error('Przebieg wizyty', error.response.data.message)
                nextSection(false)
            })
        },
        openHistory() {
            this.$refs.painHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = history
        },
        copyValue() {
            this.newValue = Array.from(new Set(this.newValue.concat(this.lastVisit[this.name])))
        }
    },

    components: {
        VisitHistoryPrevious,
        VisitHistoryModal,
        VisitHistoryItem,
        FormPain,
        FormPainBody,
        TabsSection,
        VTable
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-field_pain {
    &__history {
        width: 100%;
    }
    &__bodies {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    &__legend {
        margin-top: 1rem;
        margin-bottom: 40px;
        width: 100%;

        .c-form_input {
            margin: 0;

            &__inner {
                display: block;
            }
        }
        thead th {
            text-align: left;
        }

        tbody td {
            padding: .35rem .7rem;
            text-align: left;
        }
        &-id {
            width: 30px;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: .05rem 0;
                width: 1.4rem;
                height: 1.4rem;
                border-radius: 50%;
                background-color: $c-primary;
                color: $c-white;
                font-size: .8em;
                font-weight: 400;
            }
        }
        &-vas {
            width: 50px;
        }
    }
}

</style>

